import { ValidationSchema } from "../../../utility/validationHooks/validationAdapter";


export const courseContentValidationSchema = (isEditing = false) => {
    const schema = new ValidationSchema();

    schema.addField("title", "Content Title")
        .required("Content title is required.")
        .minLength(3)
        .maxLength(100);

    schema.addField("description", "Description")
        .required("Description is required.")
        .minLength(10);

    schema.addField("isActive", "Status")
        .required("Status is required.");

    schema.addField("contentType", "Content Type")
        .required("Content type is required.");

    schema.addField("minCompletionPercentage", "Min Completion (%)")
        .required("Completion percentage is required.")
        .minValue(0, "Value cannot be less than 0.")
        .maxValue(100, "Value cannot exceed 100.");


    schema.addField("resourceUrl", "YouTube URL")
        .custom((value, formData) => {
            if (formData.contentType === "youtube-link") {
                if (!value) return "YouTube URL is required.";

                const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+$/;
                if (!youtubeRegex.test(value)) {
                    return "Please enter a valid YouTube URL.";
                }
            }
            return null;
        });

    schema.addField("file", "Upload Video")
        .custom((value, formData) => {
            if (formData.contentType === "video") {
                const isEmpty = !value || (Array.isArray(value) && value.length === 0);
                if (!isEditing && isEmpty) return "Please upload a video file.";
            }
            return null;
        });

    schema.addField("pdfdocument", "Upload Document")
        .custom((value, formData) => {
            if (formData.contentType === "pdf") {
                const isEmpty = !value || (Array.isArray(value) && value.length === 0);
                if (!isEditing && isEmpty) return "Please upload a PDF document.";
            }
            return null;
        });



    return schema.build();
};